export enum AnnouncementListingSectionEnum{
    VipCV = -1,
    Vip = 1,
    Exclusive = 2,
    P4 = 3,
    P2 = 4,
    P1 = 5,
    Regular = 7,
    Preview = 8
}